import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { NotificationService } from './notification.service';
import { DtoNotifications, DtoNotificationType } from '../../../models/notifications.model';
import { Role } from '../../../const';
import { Tabs } from '../../package-center/package-center.component';
import { DtoPackage } from '../../../models/package-center.model';
import { PackageService } from '../../package-center/package/package.service';
import { HttpErrorResponse, JsonpInterceptor } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { SchoolService } from '../../school/school.service';
import { SharedService } from '../../../shared/services/shared.service';


export enum NotificationType { 
  SystemNotification = 0, 
  SwappedAPackage = 1, 
  RequestToUpgrade = 2, 
  RequestToUpgradeWithCustomization = 3, 
  RequestToCreateNewPackage = 4, 
  AddSchoolAfterTransfer = 5, 
  DeleteSchoolAfterTransfer = 6,
  RequestAccessToViewModuleAndSubcategory = 7,
  DataAlert = 8
}

export enum NotificationViewMode{
  UnreadMessages,
  ReadMessages,
  Archived,
  DataAlerts
}

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html'
})
export class NotificationsComponent implements OnInit, OnDestroy {
   NotificationViewMode = NotificationViewMode;
  userRole: string[] = [];
  roles = Role;
  roleName: string[] = [];
  subscription: Subscription = new Subscription();
  userEmail: string = "";
  notifications: DtoNotifications[] = [];
  filteredNotifications: DtoNotifications[] = [];

  notificationTypes: DtoNotificationType[] = [];
  notificationType = NotificationType;
  activeTab: string = Tabs.Package;
  showForm: boolean = false;
  openCreatePackage: boolean = false;
  packageToCreate: number = 0;
  notificationId: number = 0;
  packageType: number = 0;
  viewMode: NotificationViewMode = NotificationViewMode.UnreadMessages
  isLoading:boolean = true;
  
  constructor(private notificationService: NotificationService, private schoolService: SchoolService,
              private packageService: PackageService, private toasterService: ToastrService,
              private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.userEmail = sessionStorage.getItem('user_email')!;
    this.userRole = sessionStorage.getItem('user_role')?.split(',')!;
    this.userRole?.forEach(element => {
      this.roleName.push(this.getRoleNameByValue(Role, element)!);
    });

    this.fetchNotifications(this.userEmail, this.viewMode);
  }

  getRoleNameByValue<T extends { [index: string]: string }>(
    enumObj: T,
    value: string
  ): string | undefined {
    const keys = Object.keys(enumObj).filter((x) => enumObj[x] === value);
    return keys.length > 0 ? keys[0] : undefined;
  }

  archive_notification_message(notificationId:number){

    this.notificationService.archive_notification_message(notificationId)
      .subscribe({
        next: (response: any) => {
          this.fetchNotifications(this.userEmail, NotificationViewMode.ReadMessages);
        },
        error: (err: HttpErrorResponse) => {
          if (err.error) {
            this.toasterService.error(err.error, 'Error');
          }
        }
      });
  }

  fetchNotificationTypes(){

    if(this.notificationTypes.length==0)
    {
      this.notificationService
            .fetchNotificationTypes()
            .subscribe({
              next: (response) => {
                this.isLoading = false;
                this.notificationTypes = response;
                
                //init extra attributes
                for(var nt of this.notificationTypes)
                {
                  nt.notificationCount = 0;
                  nt.isFiltered = false;
                }
                this.setNotificationTypeState();
              },
              error: (err: HttpErrorResponse) => {
                this.notificationTypes=[]
                if (err.error) {
                  this.toasterService.error(err.error, 'Error');
                }
              }
            });
    }
    else{
      this.setNotificationTypeState();
    }
  }

  setNotificationTypeState(){
    for(var nt of this.notificationTypes)
    {
      const numRecords = this.notifications.filter(n=>n.notificationTypeId==nt.notificationTypeId)
        .length;
      nt.notificationCount = numRecords;
    }
    
    this.filterNotifications();
    
  }

  filterNotifications(){
    var anyFilter = this.notificationTypes.filter(x=>x.isFiltered);
    //show all if nothing is selected
    if(anyFilter.length==0){
      this.filteredNotifications = this.notifications.filter(() => true);
    }
    else
    {
      this.filteredNotifications = this.notifications.filter(x=> anyFilter.some(t=>x.notificationTypeId!=null && t.notificationTypeId==x.notificationTypeId))
    }
    
  }

  fetchNotifications(
    loggedInUser: string,
    status: NotificationViewMode
  ): void {
    this.viewMode = status;

    this.notifications=[];
    this.notificationService
      .fetchNotifications(loggedInUser, status)
      .subscribe({
        next: (response) => {
          this.notifications = response;
          
          this.fetchNotificationTypes();

          if(!this.isLoading)
          {
            //make sure te bell count is always refreshed
            this.sharedService.getUpdatedNotification(true, true);
          }
        },
        error: (err: HttpErrorResponse) => {
          if (err.error) {
            this.toasterService.error(err.error, 'Error');
          }
        }
      });
  }
  
  fetchNotificationSubscriptions(loggedInUser: string, allStatus: boolean) {
    this.viewMode = NotificationViewMode.DataAlerts;
    
    //this.notificationTypes=[];//leave to remember state
    
    //clear the array to reduce memory footprint
    this.notifications=[];
    this.filteredNotifications=[];


  }

  acceptRequest(notification: DtoNotifications){
    if(notification.referenceType == "Package"){
      this.packageService
        .approvePackageUpgrade(notification.referenceId!)
        .subscribe({
          next: (response) => {
            if (response) {
              this.fetchNotifications(this.userEmail, 0);
            }
          },
          error: (err: HttpErrorResponse) => {
            if (err.error) {
              this.toasterService.error(err.error, 'Error');
            }
          }
        });
    }
    else if(notification.referenceType == "Role"){
      this.packageService
        .approveRoleCreationRequest(notification.referenceId!)
        .subscribe({
          next: (response) => {
            if (response) {
              this.fetchNotifications(this.userEmail, 0);
            }
          },
          error: (err: HttpErrorResponse) => {
            if (err.error) {
              this.toasterService.error(err.error, 'Error');
            }
          }
        });
    }
  }

  declineRequest(notification: DtoNotifications){
    if(notification.referenceType == "Package"){
      this.packageService
        .declinePackageUpgrade(notification.referenceId!)
        .subscribe({
          next: (response) => {
            if (response) {
              this.fetchNotifications(this.userEmail, 0);
            }
          },
          error: (err: HttpErrorResponse) => {
            if (err.error) {
              this.toasterService.error(err.error, 'Error');
            }
          }
        });
    }
    else if(notification.referenceType == "Role"){
      this.packageService
        .declineRoleCreationRequest(notification.referenceId!)
        .subscribe({
          next: (response) => {
            if (response) {
              this.fetchNotifications(this.userEmail, 0);
            }
          },
          error: (err: HttpErrorResponse) => {
            if (err.error) {
              this.toasterService.error(err.error, 'Error');
            }
          }
        });
    }
  }

  grantAccess(notification: DtoNotifications){
    this.schoolService
      .grantAccessToViewReport(notification.referenceId!)
      .subscribe({
        next: (response) => {
          if (response) {
            this.fetchNotifications(this.userEmail, 0);
          }
        },
        error: (err: HttpErrorResponse) => {
          if (err.error) {
            this.toasterService.error(err.error, 'Error');
          }
        }
      });
  }

  declineAccess(notification: DtoNotifications){
    this.schoolService
      .declineAccessToViewReport(notification.referenceId!)
      .subscribe({
        next: (response) => {
          if (response) {
            this.fetchNotifications(this.userEmail, 0);
          }
        },
        error: (err: HttpErrorResponse) => {
          if (err.error) {
            this.toasterService.error(err.error, 'Error');
          }
        }
      });
  }

  transferSchool(notification: DtoNotifications){
    this.schoolService
      .transferSchool(notification.referenceId!)
      .subscribe({
        next: (response) => {
          if (response) {
            this.schoolService
              .checkIfSchoolIsTranferredToIndividualSchool(notification.referenceId!)
              .subscribe({
                next: (response) => {
                  if (response) {
                    this.toasterService.warning(
                      'Please assign account admin for the transferred school!'
                    );
                  }
                },
                error: (err: HttpErrorResponse) => {
                  if (err.error) {
                    this.toasterService.error(err.error, 'Error');
                  }
                }
              });

            this.fetchNotifications(this.userEmail, 0);
          }
        },
        error: (err: HttpErrorResponse) => {
          if (err.error) {
            this.toasterService.error(err.error, 'Error');
          }
        }
      });
  }

  createNewPackage(notification: DtoNotifications){
    this.notificationService
      .getPackageDetails(notification.referenceId!)
      .subscribe({
        next: (response: DtoPackage | any) => {
          if (response) {
            this.packageToCreate = response.packageId;
            this.notificationId = notification.notificationId!;
            this.openCreatePackage = true;
            this.showForm = true;
            this.packageType = notification.notificationTypeId!;
          }
        },
        error: (err: HttpErrorResponse) => {
          if (err.error) {
            this.toasterService.error(err.error, 'Error');
          }
        }
      });
  }

  closeForm(value: boolean){
    if(value){
      this.showForm = false;
      this.openCreatePackage = false;
      this.fetchNotifications(this.userEmail, 0);
    }
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
